__turbopack_context__.v({
  "questionRadio": "styles-module-scss-module__weDcfq__questionRadio",
  "questionRadio__card": "styles-module-scss-module__weDcfq__questionRadio__card",
  "questionRadio__error": "styles-module-scss-module__weDcfq__questionRadio__error",
  "questionRadio__errorSlot": "styles-module-scss-module__weDcfq__questionRadio__errorSlot",
  "questionRadio__grid": "styles-module-scss-module__weDcfq__questionRadio__grid",
});
